<template>
  <div>
    <b-field>
      <b-table
        :data="items"
        ref="table"
        striped
        hoverable
        scrollable
        narrowed
        sort-icon="arrow-up"
        sort-icon-size="is-small"
        default-sort="orderDate"
        default-sort-direction="desc"
        show-detail-icon
        :detailed="hasItemDetailSlot"
        :checkable="checkable"
        :checked-rows.sync="checkedItems"
        :row-class="checkBgColor"
        class="is-size-7"
      >
        <b-table-column label="FAX返信確認" centered v-if="isBooked">
          <template #header="{ column }">
            <b-checkbox
              class="column-checkbox"
              v-model="faxFlg"
              @input="filterItems()"
              >{{ column.label }}</b-checkbox
            >
          </template>
          <template v-slot="props">
            <b-checkbox
              class="row-checkbox"
              v-model="props.row.confirmFaxReply"
              @input="saveItem(props.row)"
            ></b-checkbox>
          </template>
        </b-table-column>
        <b-table-column label="納車確定確認" centered v-if="isBooked">
          <template #header="{ column }">
            <b-checkbox
              class="column-checkbox"
              v-model="deliveryFlg"
              @input="filterItems()"
              >{{ column.label }}</b-checkbox
            >
          </template>
          <template v-slot="props">
            <b-checkbox
              class="row-checkbox"
              v-model="props.row.confirmOfDelivery"
              @input="saveItem(props.row)"
            ></b-checkbox>
          </template>
        </b-table-column>
        <b-table-column
          label="受注"
          field="orderDate"
          v-slot="props"
          sortable
          :custom-sort="sortDate('orderDate')"
          centered
        >
          {{ props.row.orderDate | formatDateString('M/D') }}
        </b-table-column>
        <b-table-column label="車台番号" field="vinNo" v-slot="props" sortable>
          <a @click="itemClick(props.row)">
            {{ props.row.vinNo }}
          </a>
        </b-table-column>
        <b-table-column label="車種" field="model" v-slot="props" sortable>
          {{ props.row.model }}
        </b-table-column>
        <b-table-column
          label="ナンバー"
          field="hasNumberPlate"
          v-slot="props"
          :custom-sort="sortNumberPlate"
          sortable
        >
          <span v-show="props.row.hasNumberPlate">
            有
            <span v-show="props.row.transportOptionNumberPlateCut">
              (要カット)
            </span>
          </span>
        </b-table-column>

        <b-table-column
          label="状態"
          field="conditionChecked"
          v-slot="props"
          width="150"
          :custom-sort="sortCondition"
          sortable
        >
          <b-icon
            pack="fas"
            icon="check-circle"
            type="is-success"
            v-show="props.row.conditionChecked"
          />
          {{ props.row.getRemarks() }}
        </b-table-column>
        <b-table-column
          label="引取先"
          field="transportFromName"
          v-slot="props"
          sortable
        >
          {{
            (props.row.isOpenSearchAddressByZipCodePopupFlag == true && (props.row.suppliersName || props.row.addressByZipcode) )?
            (props.row.suppliersName ? ( props.row.suppliersName +  (props.row.addressByZipcode ? ' - ' + props.row.addressByZipcode : '' )) : props.row.addressByZipcode) :
            (props.row.yardTransportName
              ? props.row.yardTransportName
              : props.row.transportFromName)
          }}
        </b-table-column>
        <b-table-column
          label="出品番号"
          field="Lotno"
          v-slot="props"
          numeric
          sortable
        >
          {{ props.row.lotNo | formatNumber }}
        </b-table-column>
        <b-table-column
          label="納車先 "
          field="transportToName"
          v-slot="props"
          :custom-sort="sortTransportTo"
          sortable
        >
          {{ transportTo(props.row) }}
        </b-table-column>
        <!--START QuocNV add item handling_company_jp -->
        <b-table-column v-if="!isOrders"
          label="取扱い "
          field="handlingCompanyJp"
          v-slot="props"
          :custom-sort="sortHandlingCompanyJP"
          sortable
        >
          {{ props.row.handlingCompanyJp }}
        </b-table-column>
        <!--END QuocNV add item handling_company_jp -->
        <b-table-column
          label="陸送会社"
          field="transportVendorName"
          v-slot="props"
          sortable
        >
          {{ props.row.transportVendorName }}
        </b-table-column>
        <b-table-column
          label="顧客ID"
          field="customerId"
          v-slot="props"
          sortable
        >
          {{ props.row.customerId }}
        </b-table-column>
        <b-table-column
          label="Grade"
          field="customerGrade"
          numeric
          v-slot="props"
          sortable
        >
          {{ props.row.customerGrade }}
        </b-table-column>
        <b-table-column
          label="費用合計"
          field="transportTotalActualCost"
          v-slot="props"
          numeric
          sortable
        >
          {{ props.row.transportTotalActualCost | formatNumber }}
        </b-table-column>
        <b-table-column
          label="陸送請求額"
          field="transportCost"
          v-slot="props"
          numeric
          sortable
        >
          <div :class="getClassTransportCost(props.row)">
          {{ props.row.transportCost | formatNumber }}
          </div>
        </b-table-column>
        <b-table-column
          label="請求合計"
          :header-class="getClassTransportTotalCost"
          field="transportTotalCost"
          v-slot="props"
          numeric
          sortable
        >
          <div :class="getClassTransportTotalCost(props.row)">
          {{ props.row.transportTotalCost | formatNumber }}
          </div>
        </b-table-column>
        <!-- START QUOCNV 20231115 add new item  -->
        <b-table-column
          label="陸送費確認"
          v-if="isBooked"
          field="dateConfirmFeeTransport"
          v-slot="props"
          :custom-sort="sortDateConfirmFeeTransport"
          sortable
        >
          <b-icon
            pack="fas"
            icon="check-circle"
            type="is-success"
            v-show="props.row.dateConfirmFeeTransport"
          />
        </b-table-column>
        <!-- END QUOCNV 20231115 add new item  -->
        <b-table-column
          v-if="isBooked"
          label="請求書確認日"
          field="transportRequestDate"
          v-slot="props"
          sortable
          :custom-sort="sortDate('transportRequestDate')"
          centered
        >
          {{ props.row.transportRequestDate | formatDateString('M/D') }}
        </b-table-column>
        <!-- <b-table-column
          v-if="isOrders"
          label="手配"
          field="transportRequestDate"
          v-slot="props"
          sortable
          :custom-sort="sortDate('transportRequestDate')"
          centered
        >
          {{ props.row.transportRequestDate | formatDateString('M/D') }}
        </b-table-column> -->
        <b-table-column
          label="手配完了"
          field="transportRequestConfirmDate"
          v-slot="props"
          sortable
          :custom-sort="sortDate('transportRequestConfirmDate')"
          centered
        >
          {{ props.row.transportRequestConfirmDate | formatDateString('M/D') }}
        </b-table-column>
        <b-table-column
          label="納車予定"
          field="transportEstimatedArrivalDate"
          v-slot="props"
          sortable
          :custom-sort="sortDate('transportEstimatedArrivalDate')"
          centered
        >
          {{
            props.row.transportEstimatedArrivalDate | formatDateString('M/D')
          }}
        </b-table-column>
        <!--START 20231017 QuocNV add new Item  -->
        <b-table-column
          :header-class="headerClass"
          :cell-class="cellClass"
          v-if="isBooked"
          label="請求書作成日"
          field="invoiceIsuueDate"
          v-slot="props"
          sortable
          :custom-sort="sortDate('invoiceIsuueDate')"
          centered
        >
          {{
            props.row.invoiceIsuueDate | formatDateString('M/D')
          }}
        </b-table-column>
        <!--END 20231017 QuocNV add new Item  -->
        <template slot="detail" slot-scope="props">
          <slot :item="props.row"></slot>
        </template>
      </b-table>
    </b-field>
  </div>
</template>
<style scoped>
.icon {
  font-size: 0.7rem !important;
}
.column-checkbox {
  width: 48px;
}
::v-deep table thead .checkbox-cell {
  padding: 7px 0 0 7px !important;
  min-width: 20px!important;
  width: 20px!important;
}
.row-checkbox {
  padding-top: 3px;
}
::v-deep .v-color-row {
  background-color: #ffffc4 !important;
}
</style>
<style>
.is-size-7 table {
  width: 98%!important;
  border: 1px solid #f2effb!important;
  border-radius: 4px;
  border-collapse: separate;
  padding: 5px;
}
.b-table .table th {
  min-width: 60px;
}

.container  {
  margin-bottom: 20px;
  padding: 0px!important;
  max-width: 1644px!important;
}
.b-table .table th.is-current-sort {
  min-width: 100px!important;
  padding-right: 15px!important;
}

.is-current-sort .th-wrap .icon {
    margin-left: 0px!important;
    margin-right: 10px!important;
    font-size: 0.7rem!important;
    color: #f14668;
}
.my-header-class{
  min-width: 30px !important;
  width: 40px;
  max-width: 40px;
}
/* .my-header-class .th-wrap{
  padding-left: 10px;
  padding-right: 10px;
} */
.header-check-fee{
  background-color: red;
  font-weight: 800;
}
</style>
<script>
import moment from 'moment';
export default {
  props: [
    'items',
    'checkable',
    'isBooked',
    'isOrders',
    'isAllBooked',
    'isOrder',
    'isBookedItem',
  ],
  data: () => ({
    checkedItems: [],
    faxFlg: false,
    deliveryFlg: false,
  }),
  computed: {
    hasItemDetailSlot() {
      return !!this.$scopedSlots.default;
    },
    headerClass() {
      return "my-header-class";
    },
    cellClass() {
      return "my-cell-class";
    },
  },
  watch: {
    checkedItems: function () {
      this.$emit('onUpdateCheckedItems', {
        uid: this._uid,
        items: this.checkedItems,
      });
    },
  },
  methods: {
    itemClick(item) {
      this.$emit('item-click', { item, items: this.$refs.table.newData });
    },
    transportTo(item) {
      const to = this.$store.getters.yardVendor(item.transportToId);
      return to ? to.YardName.value : item.transportToName;
    },
    sortNumberPlate(a, b, isAsc) {
      const x = `${a.hasNumberPlate}${a.transportOptionNumberPlateCut}`;
      const y = `${b.hasNumberPlate}${b.transportOptionNumberPlateCut}`;
      return isAsc ? (x > y ? 1 : -1) : x > y ? -1 : 1;
    },
    sortCondition(a, b, isAsc) {
      const x = `${a.conditionChecked}${a.getRemarks()}`;
      const y = `${b.conditionChecked}${b.getRemarks()}`;
      return isAsc ? (x > y ? 1 : -1) : x > y ? -1 : 1;
    },
    sortTransportTo(a, b, isAsc) {
      const x = this.transportTo(a).trim();
      const y = this.transportTo(b).trim();
      return isAsc ? (x > y ? 1 : -1) : x > y ? -1 : 1;
    },
    sortHandlingCompanyJP(a, b, isAsc) {
      const x = a.handlingCompanyJp;
      const y = b.handlingCompanyJp;
      return isAsc ? (x > y ? 1 : -1) : x > y ? -1 : 1;
    },
    sortDateConfirmFeeTransport(a,b,isAsc){
      const x = moment(a[key]).format('YYYY/MM/DD');
      const y = moment(b[key]).format('YYYY/MM/DD');
      return isAsc ? (x > y ? 1 : -1) : x > y ? -1 : 1;
    },
    sortDate(key) {
      return function (a, b, isAsc) {
        const x = moment(a[key]).format('YYYY/MM/DD');
        const y = moment(b[key]).format('YYYY/MM/DD');
        return isAsc ? (x > y ? 1 : -1) : x > y ? -1 : 1;
      };
    },
    checkBgColor(item) {
      if (!item.confirmFaxReply && !item.confirmOfDelivery && this.isBooked && !item.dateConfirmFeeTransport) {
        return 'v-color-row';
      }
      return '';
    },
    filterItems() {
      const filterItem = {
        faxFlg: this.faxFlg,
        deliveryFlg: this.deliveryFlg,
      };
      this.$emit('filterListItem', filterItem);
    },
    saveItem(item) {
      this.$store.dispatch('saveItem', item);
    },
    getClassTransportCost(value) {
      if ( value && (parseFloat(value.transportActualCost) > parseFloat(value.transportCost)) && value.dateConfirmFeeTransport =='') {
        return 'header-check-fee';
      }
      return '';
    },
    getClassTransportTotalCost(value) {
      if ( value && (parseFloat(value.transportTotalActualCost) > parseFloat(value.transportTotalCost)) && value.dateConfirmFeeTransport =='') {
        return 'header-check-fee';
      }
      return '';
    },
    clearCheckedItems(){
      this.checkedItems = [];
    }
  }
};
</script>
